<div class="fx--v fx--text" *ngIf="$propertySet() as propertySet">
  <!-- ps name -->
  <div class="fx--h fx--ali-center fx--mb-xs">
    <h2 id="propertySetName" class="fx--subtitle fx--black-text fx--mr-md ps-summary-title">{{ propertySet?.name }}</h2>
    <div
      class="fx--h edit-button"
      matTooltip="Only Research Users with 'Owner' access can edit Statistical Property Sets"
      [matTooltipPosition]="'above'"
      [matTooltipDisabled]="
        !(propertySet?.level === UserPermissionLevel.Owner && propertySet?.is_statistical && !isUSResearcher)
      "
    >
      <a
        mat-button
        id="editButton"
        (click)="toggleEditMode()"
        class="fx--h fx--ali-center"
        *ngIf="propertySet?.level === UserPermissionLevel.Owner"
        [disabled]="propertySet?.level === UserPermissionLevel.Owner && propertySet?.is_statistical && !isUSResearcher"
      >
        <mat-icon>edit</mat-icon>
        <span>EDIT DETAILS</span>
      </a>
    </div>
  </div>
  <div class="fx--h fx--ali-center fx--mb-xs ps-summary-label" *ngIf="propertySet?.is_statistical">
    <span class="statistical-chip">S</span>
    <span class="fx--text__bold fx--mr-xs ps-summary-label--statistical"> &nbsp; Statistical Set </span>
    <span> {{ propertySet?.publishing_sector || 'No Publishing Sector' }}</span>
    <span class="ps-summary-label--with-border">
      {{ propertySet?.publishing_group || 'No Publishing Group' }}
    </span>
  </div>
  <div class="fx--h fx--ali-center fx--mb-xs ps-summary-label">
    <span class="ps-summary-label--without-border">{{
      propertySet?.markets?.join(', ') || 'Markets Placeholder'
    }}</span>
    <span class="ps-summary-label--with-border">{{
      propertySet?.property_type?.join(', ') || 'No Property Types'
    }}</span>
  </div>
  <div class="fx--h fx--ali-center ps-summary-label">
    {{ propertySet?.description }}
  </div>
</div>
